import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import BaseScreen from '/component/partial/BaseScreen/BaseScreen';
import {getRefreshedMetrics} from '/redux/action/metric.action';
import {nextRankIdById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    userId,
    rankId: withCurrentUserCoachId(nextRankIdById),
  }),
  dispatch => ({
    getRefreshedMetrics: ({coachId, rankId}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getRefreshedMetrics({coachId, rankId})),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const {userId: coachId, rankId} = stateProps;

    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      refreshCachedMetrics: () =>
        dispatchProps.getRefreshedMetrics({coachId, rankId}),
    };
  },
)(BaseScreen);
